import React from 'react';
import { copyStringToClipboard } from 'system/libs/copyStringToClipboard';
import { ChartGroup, randomHelper } from 'utils/randomHelper';

import {
    BasicField,
    BasicFieldProps,
} from 'reactApp/components/Forms/_BasicField';
import {
    formikContextConnector,
    FormikContextConnectorProps,
} from 'reactComponents/Forms/ConnectFormikContext';
import { ToastNotify } from 'reactComponents/ToastNotify/ToastNotify';

import { InputPassword } from './InputPassword/InputPassword';

type OwnProps = {
    name: string;
    charts?: string;
    groupCharts?: ChartGroup[];
    noAutoComplete?: boolean;
    showGenerateButton?: boolean;
    shouldShowPassword?: boolean;
    maxLength?: number;
    showCopyButton?: boolean;
    showCopyIcon?: boolean;
    autoComplete?: string;
    value?: string;
    fullWidth?: boolean;
    itemName?: string;
};
type Props = OwnProps &
    FormikContextConnectorProps &
    Omit<BasicFieldProps, 'control'>;
class _FieldPassword extends React.Component<Props> {
    static defaultProps = {
        label: 'Пароль',
        name: 'password',
        itemName: 'Пароль',
    };

    _fieldRef: HTMLInputElement | null = null;

    get _formikParams() {
        return this.props._formikContext;
    }

    _generatePassword = () => {
        const { groupCharts, charts, itemName } = this.props;
        const password = groupCharts
            ? randomHelper.generateStringWithGroups(groupCharts)
            : randomHelper.generateString(14, charts);

        this._formikParams.setFieldValue(this.props.name, password);

        copyStringToClipboard(password);

        ToastNotify.success(
            `${itemName} сгенерирован и скопирован в буфер обмена`,
        );

        setTimeout(() => {
            // need this for formik to recheck is field valid after setFieldValue
            // because there is very complicated regexp for db password validation
            // maybe need TODO: change setFieldValue to revalidate field on complete
            const inputRef = this._getActualInputRef();
            if (!inputRef) {
                return;
            }
            inputRef.focus();
            inputRef.blur();
            inputRef.focus();
        }, 0);
    };

    _getActualInputRef = () => this._fieldRef?.getElementsByTagName('input')[0];

    // this is hack cause most browsers ignore autocomplete property for password
    _avoidPasswordManager = (input) => {
        input.readOnly = true;
        setTimeout(() => {
            input.readOnly = false;
        }, 0);
    };

    _handleFocus = (event) => {
        const { noAutoComplete } = this.props;

        if (noAutoComplete) {
            this._avoidPasswordManager(event.target);
        }
    };

    _handleChange = (event, data, prevValue) => {
        const { onChange, noAutoComplete } = this.props;

        if (noAutoComplete && !event.target.value.length) {
            this._avoidPasswordManager(event.target);
        }

        if (onChange) {
            onChange(event, data, prevValue);
        }
    };

    render() {
        const {
            label,
            name,
            showGenerateButton,
            fullWidth,
            _formikContext,
            noAutoComplete,
            onChange,
            groupCharts,
            itemName,
            ...otherInputProps
        } = this.props;

        return (
            <BasicField
                {...{
                    label,
                    name,
                    control: InputPassword,
                    innerRef: (fieldNode) => {
                        this._fieldRef = fieldNode;
                    },
                    generatePassword: this._generatePassword,
                    showGenerateButton,
                    fullWidth,
                    autoComplete: noAutoComplete && 'off',
                    onChange: this._handleChange,
                    onFocus: this._handleFocus,
                    ...otherInputProps,
                }}
            />
        );
    }
}

export const FieldPassword = formikContextConnector(_FieldPassword);
